import type { NexusHandler } from "@otto-ec/global-resources/nexus";
import {
    appType as detectAppType,
    appVersion as detectAppVersion,
    supportedAppVersion as detectSupportedAppVersion,
    supportsFeature as detectSupportsFeature,
} from "./appInfo.js";
import type { AppsGlobal } from "./index.js";

export const runningInApp: NexusHandler<AppsGlobal["runningInApp"]> = () => {
    return !!window.o_apps_android || !!window.webkit?.messageHandlers;
}

export const appType: NexusHandler<AppsGlobal["appType"]> = () => {
    return detectAppType();
}

export const appVersion: NexusHandler<AppsGlobal["appVersion"]> = async () => {
    return detectAppVersion();
}

export const supportedAppVersion: NexusHandler<AppsGlobal["supportedAppVersion"]> = async (minAppVersions) => {
    return detectSupportedAppVersion(minAppVersions);
}

export const supportsFeature: NexusHandler<AppsGlobal["supportsFeature"]> = async (feature) => {
    return detectSupportsFeature(feature);
}
